import { render, staticRenderFns } from "./VendorTile.vue?vue&type=template&id=7b94711b&scoped=true&"
import script from "./VendorTile.vue?vue&type=script&lang=js&"
export * from "./VendorTile.vue?vue&type=script&lang=js&"
import style0 from "./VendorTile.vue?vue&type=style&index=0&id=7b94711b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b94711b",
  null
  
)

export default component.exports